<div class="error-page platform-not-supported">
	<header>
		<div class="logo">
			<img src="" />
		</div>
	</header>

	<article text-center>
		<img src="" [alt]="'not-supported.channel.title' | translate" />
		<h2>{{ "not-supported.channel.title" | translate }}</h2>
		<p>{{ "not-supported.channel.message" | translate }}</p>
	</article>
</div>
